const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const TOKEN_RE =
  /^[a-zA-Z0-9_-]{16,128}$/;

export type SecurePublicInviteReference = {
  inviterId: string;
  token: string;
  canonicalPath: string;
};

function parseCandidateUrl(
  raw: string,
): URL | null {
  const trimmed = raw.trim();

  if (!trimmed) {
    return null;
  }

  try {
    return new URL(
      trimmed.startsWith('http://') ||
        trimmed.startsWith('https://')
        ? trimmed
        : `https://${trimmed}`,
    );
  } catch {
    return null;
  }
}

export function parseSecurePublicInviteReference(
  raw: string,
): SecurePublicInviteReference | null {
  const url = parseCandidateUrl(raw);

  if (!url) {
    return null;
  }

  const parts =
    url.pathname
      .split('/')
      .filter(Boolean);

  const routeIndex =
    parts.findIndex(
      part =>
        part === 'invite' ||
        part === 'join',
    );

  if (routeIndex < 0) {
    return null;
  }

  const inviterId =
    parts[routeIndex + 1] ?? '';

  const token =
    (
      url.searchParams.get('t') ??
      url.searchParams.get('token') ??
      ''
    ).trim();

  if (
    !UUID_RE.test(inviterId) ||
    !TOKEN_RE.test(token)
  ) {
    return null;
  }

  return {
    inviterId,
    token,
    canonicalPath:
      `/invite/${inviterId}?t=` +
      encodeURIComponent(token),
  };
}

export function isSecurePublicInviteReference(
  raw: string,
): boolean {
  return (
    parseSecurePublicInviteReference(raw) !==
    null
  );
}
